import { SchedulerResourceValueObject } from '../value-objects/scheduler-resource.value-object'

export class SchedulerResourceValueObjectCollection {

  static colors = {
    '#9dd6146b': [
      '#98cc1a36'
    ],
    '#cc1a1a73': [
      '#cc1a1a36'
    ],
    '#1d1acc6b': [
      '#1d1acc33'
    ],
    '#f5af13a1': [
      '#f5af1370'
    ]
  }

  constructor () {
    /**
     *
     * @type {SchedulerResourceValueObject[]}
     * @private
     */
    this._items = []
    this._colors = {}
  }

  get items () {
    return this._items
  }

  /**
   *
   * @param item
   */
  push (item) {
    this._items.push(item)
  }

  /**
   *
   * @returns {[]}
   */
  toApiObjects () {
    let output = []

    this.items.forEach((item) => {
      output.push(item.toApiObject())
    })

    return output
  }

  /**
   *
   * @param resourceId
   * @returns string|null
   */
  getResourceTable (resourceId) {
    for (const resource of this.items) {
      if (resource.idUserGroup === resourceId) {
        return resource.resourceTable
      }
    }

    return null
  }

  /**
   *
   * @returns {[]}
   */
  toCalendarObjects (translate, filter = null) {
    let output = []
    let temp   = {}

    this.items.forEach((item) => {
      if (!temp.hasOwnProperty(item.branch)) {
        temp[item.branch] = {}
        if (!temp[item.branch].hasOwnProperty(item.resourceTypeName)) {
          temp[item.branch][item.resourceTypeName] = []
          temp[item.branch][item.resourceTypeName].push(item)
        }
        else {
          temp[item.branch][item.resourceTypeName].push(item)
        }
      }
      else {
        if (!temp[item.branch].hasOwnProperty(item.resourceTypeName)) {
          temp[item.branch][item.resourceTypeName] = []
          temp[item.branch][item.resourceTypeName].push(item)
        }
        else {
          temp[item.branch][item.resourceTypeName].push(item)
        }
      }

    })

    let id = 1
    Object.keys(temp).forEach((key) => {
      const colors = this.findBranchColor(key)
      const item   = {
        id:        'l1' + id,
        title:     translate.text(key),
        children:  [],
        color:     colors.branch,
        fontColor: colors.font
      }

      Object.keys(temp[key]).forEach((secondKey) => {
        id++
        const colors     = this.findColor(secondKey)
        const secondItem = {
          id:            'l2' + id,
          title:         translate.text(secondKey),
          children:      [],
          color:         colors.branch.replace('##', '#'),
          fontColor:     colors.font,
          resourceApiId: null
        }

        temp[key][secondKey].forEach((tempItem) => {
          secondItem.children.push({
            id:        tempItem.idUserGroup + '-' + tempItem.resourceTable,
            title:     translate.text(tempItem.resourceName),
            color:     tempItem.userGroupNameColor.replace('##', '#'),
            fontColor: tempItem.fontColor,
            table:     tempItem.resourceTable,
            avatar:    tempItem.avatar,
            skills:    tempItem.skills,
            children:  []
          })
        })

        item.children.push(secondItem)
      })

      output.push(item)

      id++
    })

    return output
  }

  findBranchColor (branch) {
    for (const item of this.items) {
      if (item.branch === branch) {
        return { branch: item.branchColor, font: item.fontColor }
      }
    }
  }

  findColor (name) {
    for (const item of this.items) {
      if (item.resourceTypeName === name) {
        return { branch: item.branchNameColor, font: item.fontColor }
      }
    }
  }
}
